module.exports = __webpack_public_path__ + "static/media/zx-spec.afea36fe.gif";